module.exports = __webpack_public_path__ + "static/NbMapLocation-4f59ae042a605a3a0da94408d04e3a2c.jpg";